import { useState } from "react";
import { AuthForm } from "./components/AuthForm";
import { EventView } from "./components/EventView";
import { EventSelection } from "./components/EventSelection";
import { ConfirmationView } from "./components/ConfirmationView";
import { AuthResponse, MultipleEventsResponse } from "./types";
import "./App.css";

type AppState = "auth" | "event-selection" | "event" | "confirmation";

function App() {
  const [state, setState] = useState<AppState>("auth");
  const [authData, setAuthData] = useState<AuthResponse | null>(null);
  const [multipleEventsData, setMultipleEventsData] =
    useState<MultipleEventsResponse | null>(null);
  const [phone, setPhone] = useState<string>("");

  const handleAuthenticated = (
    data: AuthResponse | MultipleEventsResponse,
    phone: string
  ) => {
    setPhone(phone);

    // Check if this is multiple events response
    if ("multipleEvents" in data && data.multipleEvents) {
      setMultipleEventsData(data);
      setState("event-selection");
    } else {
      // Single event - backward compatibility
      setAuthData(data as AuthResponse);
      setState("event");
    }
  };

  const handleEventSelect = (selectedEventData: AuthResponse) => {
    setAuthData(selectedEventData);
    setState("event");
  };

  const handleBackToSelection = () => {
    setState("event-selection");
  };

  const handleBackToAuth = () => {
    setState("auth");
    setAuthData(null);
    setMultipleEventsData(null);
    setPhone("");
  };

  const handleRSVPComplete = () => {
    setState("confirmation");
  };

  return (
    <div className="app" data-state={state}>
      {state === "auth" && <AuthForm onAuthenticated={handleAuthenticated} />}

      {state === "event-selection" && multipleEventsData && (
        <EventSelection
          events={multipleEventsData.events}
          onEventSelect={handleEventSelect}
          onBack={handleBackToAuth}
        />
      )}

      {state === "event" && authData && (
        <EventView
          authData={authData}
          phone={phone}
          accessCode={phone}
          onRSVPComplete={handleRSVPComplete}
          onBackToSelection={handleBackToSelection}
          hasMultipleEvents={!!multipleEventsData}
        />
      )}

      {state === "confirmation" && authData && (
        <ConfirmationView
          eventData={authData}
          onBackToEvent={() => setState("event")}
        />
      )}
    </div>
  );
}

export default App;
// Force rebuild with new styles - v2
